declare global {
  interface Window {
    Trustpilot?: {
      loadFromElement: (element: Element) => void;
    };
  }
}

function initializeTrustpilot() {
  const widgets = document.querySelectorAll(".trustpilot-widget");
  if (!widgets.length) return;

  if (window.Trustpilot) {
    setTimeout(() => {
      widgets.forEach((widget) => {
        try {
          window.Trustpilot!.loadFromElement(widget);
        } catch (e) {
          console.warn("Error initializing Trustpilot widget:", e);
        }
      });
    }, 100);
    return;
  }

  if (!document.getElementById("trustpilot-script")) {
    const script = document.createElement("script");
    script.id = "trustpilot-script";
    script.type = "text/javascript";
    script.src = "https://widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js";
    script.async = true;
    script.defer = true;
    script.onload = () => {
      if (window.Trustpilot) {
        document.querySelectorAll(".trustpilot-widget").forEach((widget) => {
          try {
            window.Trustpilot!.loadFromElement(widget);
          } catch (e) {
            console.warn("Error initializing Trustpilot widget:", e);
          }
        });
      }
    };
    document.body.appendChild(script);
  }
}

export default defineNuxtPlugin(() => {
  if (!import.meta.client) return;

  const router = useRouter();

  // Re-init on every navigation
  router.afterEach(() => {
    setTimeout(initializeTrustpilot, 300);
  });

  // Init on first load
  if (document.readyState === "complete") {
    setTimeout(initializeTrustpilot, 300);
  } else {
    window.addEventListener("load", () => setTimeout(initializeTrustpilot, 300));
  }
});
